import React from 'react';
import { IonButton, IonLoading, IonRouterLink } from '@ionic/react';

import {
  Formik,
  Field,
  Form,
  FormikHelpers,
  ErrorMessage,
  FormikProps,
} from 'formik';
import * as Yup from 'yup';

import styles from './LoginForm.module.css';

import { userLogin, saveUserCredentials, AppError } from '../lib/functionality';

interface LoginFormProps {
  navigateToAccount: () => void;
}

interface LoginFormValues {
  email: string;
  password: string;
}

const defaultValues: LoginFormValues = {
  email: '',
  password: '',
};

const LoginFormSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
  password: Yup.string().required('Required'),
});

const LoginForm = ({ navigateToAccount }: LoginFormProps) => {
  const onFormSubmit = async (
    values: LoginFormValues,
    { setSubmitting, setStatus }: FormikHelpers<LoginFormValues>,
  ) => {
    setSubmitting(true);
    try {
      const userToken = await userLogin(values.email, values.password);
      await saveUserCredentials(values.email, values.password, userToken);
      navigateToAccount();
    } catch (err) {
      setStatus((err as AppError).message);
    }
  };
  return (
    <div className={styles.component}>
      <Formik
        initialValues={defaultValues}
        onSubmit={onFormSubmit}
        validationSchema={LoginFormSchema}
        validateOnBlur={true}>
        {(props: FormikProps<LoginFormValues>) => {
          const { isSubmitting, status } = props;
          return (
            <Form>
              <IonLoading
                showBackdrop={true}
                animated={true}
                isOpen={isSubmitting}
                message="Logging in..."
              />

              {status && <span className={styles.formError}>{status}</span>}

              <div className={styles.formRow}>
                <Field
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Username / Email"
                  disabled={isSubmitting}
                />
                <ErrorMessage name="email">
                  {msg => <span className={styles.error}>{msg}</span>}
                </ErrorMessage>
              </div>
              <div className={styles.formRow}>
                <Field
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Password"
                  disabled={isSubmitting}
                />
                <ErrorMessage name="password">
                  {msg => <span className={styles.error}>{msg}</span>}
                </ErrorMessage>
              </div>
              <div className={styles.formRow}>
                <IonButton type="submit" expand="block" disabled={isSubmitting}>
                  Login
                </IonButton>
              </div>
              <div className={styles.formRowActions}>
                <IonRouterLink routerLink="registration">
                  Register
                </IonRouterLink>
                {/* <a href="#">Forgot Password</a> */}
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default LoginForm;
